import * as t from "react";
import { jsx as c } from "react/jsx-runtime";
import W from "clsx";
const i2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12.233 6.045a1.125 1.125 0 0 0-1.591-1.59l-6.75 6.75a1.123 1.123 0 0 0 0 1.59l6.75 6.75a1.125 1.125 0 0 0 1.591-1.59l-4.83-4.83h11.91a1.125 1.125 0 0 0 0-2.25H7.402l4.83-4.83Z", fill: "currentColor" })), s2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M13.358 4.455a1.125 1.125 0 0 0-1.591 1.59l4.83 4.83H4.686a1.125 1.125 0 0 0 0 2.25h11.91l-4.83 4.83a1.125 1.125 0 0 0 1.591 1.59l6.75-6.75c.44-.439.44-1.151 0-1.59l-6.75-6.75Z", fill: "currentColor" })), C2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.625 1.875C5.625 1.52982 5.34518 1.25 5 1.25C4.65482 1.25 4.375 1.52982 4.375 1.875V2.5H3.75C2.36929 2.5 1.25 3.61929 1.25 5V6.25V16.25C1.25 17.6307 2.36929 18.75 3.75 18.75H16.25C17.6307 18.75 18.75 17.6307 18.75 16.25V6.25V5C18.75 3.61929 17.6307 2.5 16.25 2.5H15.625V1.875C15.625 1.52982 15.3452 1.25 15 1.25C14.6548 1.25 14.375 1.52982 14.375 1.875V2.5H5.625V1.875ZM17.5 5.625V5C17.5 4.30964 16.9404 3.75 16.25 3.75H15H5H3.75C3.05964 3.75 2.5 4.30964 2.5 5V5.625H17.5ZM2.5 6.875H17.5V16.25C17.5 16.9404 16.9404 17.5 16.25 17.5H3.75C3.05964 17.5 2.5 16.9404 2.5 16.25V6.875Z", fill: "currentColor" })), c2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M18.75 22.5a.75.75 0 0 1-.498-.188L12 16.755l-6.252 5.558A.75.75 0 0 1 4.5 21.75V4.5a3.003 3.003 0 0 1 3-3h9a3.003 3.003 0 0 1 3 3v17.25a.75.75 0 0 1-.75.75Z", fill: "currentColor" })), d2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.994 5.436a.75.75 0 0 1 .07 1.058l-10.5 12a.75.75 0 0 1-1.094.036l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.933 3.933 9.973-11.397a.75.75 0 0 1 1.058-.07Z", fill: "currentColor" })), u2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("rect", { x: 1, y: 1, width: 18, height: 18, rx: 3, strokeWidth: 2 })), p2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM15.2043 6.64856L8.74279 14.3409C8.67191 14.4253 8.58371 14.4935 8.48417 14.5409C8.38463 14.5882 8.27608 14.6136 8.16586 14.6154H8.15288C8.04506 14.6154 7.93846 14.5926 7.83998 14.5488C7.7415 14.5049 7.65335 14.4407 7.58125 14.3606L4.81202 11.2837C4.74169 11.2091 4.68698 11.1212 4.65111 11.0251C4.61523 10.9291 4.59892 10.8269 4.60313 10.7244C4.60733 10.622 4.63197 10.5214 4.67559 10.4287C4.71921 10.3359 4.78094 10.2528 4.85715 10.1842C4.93335 10.1156 5.0225 10.0629 5.11934 10.0293C5.21619 9.99568 5.31878 9.98174 5.42109 9.98832C5.52339 9.9949 5.62335 10.0219 5.71509 10.0676C5.80683 10.1134 5.88849 10.177 5.95529 10.2548L8.13269 12.674L14.0264 5.65914C14.1586 5.5063 14.3457 5.41161 14.5471 5.39556C14.7486 5.37951 14.9483 5.44337 15.103 5.57336C15.2577 5.70334 15.3551 5.88899 15.3741 6.09019C15.393 6.29139 15.3321 6.49196 15.2043 6.64856Z" })), v2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.455 7.83a1.123 1.123 0 0 1 1.59 0L12 13.784l5.954-5.955a1.125 1.125 0 0 1 1.591 1.592l-6.75 6.75a1.124 1.124 0 0 1-1.59 0l-6.75-6.75a1.125 1.125 0 0 1 0-1.591Z", fill: "currentColor" })), g2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "m6.214 10.501 5.12 6.182c.082.1.184.179.3.234a.854.854 0 0 0 1.034-.235l5.119-6.18c.488-.59.083-1.502-.668-1.502H6.88c-.75 0-1.156.911-.666 1.501Z", fill: "currentColor" })), f2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.204 7.83c.44-.44 1.152-.44 1.591 0l6.75 6.75a1.125 1.125 0 0 1-1.59 1.59L12 10.216l-5.955 5.955a1.125 1.125 0 0 1-1.59-1.591l6.75-6.75Z", fill: "currentColor" })), m2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25Zm3.53 12.22a.75.75 0 1 1-1.06 1.06L12 13.06l-2.47 2.47a.75.75 0 0 1-1.06-1.06L10.94 12 8.47 9.53a.75.75 0 0 1 1.06-1.06L12 10.94l2.47-2.47a.75.75 0 0 1 1.06 1.06L13.06 12l2.47 2.47Z", fill: "currentColor" })), w2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.22 6.22a.75.75 0 0 1 1.06 0l10.5 10.5a.75.75 0 1 1-1.06 1.06L6.22 7.28a.75.75 0 0 1 0-1.06Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.78 6.22a.75.75 0 0 1 0 1.06l-10.5 10.5a.75.75 0 0 1-1.06-1.06l10.5-10.5a.75.75 0 0 1 1.06 0Z", fill: "currentColor" })), h2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.75 3a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5v-9.129a.75.75 0 0 0-.22-.53L11.91 3.22a.75.75 0 0 0-.53-.22H6.75Zm-2.121-.621A3 3 0 0 1 6.75 1.5h4.629a2.25 2.25 0 0 1 1.59.659l6.622 6.622c.422.421.659.993.659 1.59V19.5a3 3 0 0 1-3 3H6.75a3 3 0 0 1-3-3v-15a3 3 0 0 1 .879-2.121Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 1.875a.75.75 0 0 1 .75.75V8.25a.75.75 0 0 0 .75.75h5.625a.75.75 0 0 1 0 1.5H13.5a2.25 2.25 0 0 1-2.25-2.25V2.625a.75.75 0 0 1 .75-.75ZM7.5 13.5a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75Zm0 3.75a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75Z", fill: "currentColor" })), b2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 1.5C12.4142 1.5 12.75 1.83579 12.75 2.25V14.6893L15.2197 12.2197C15.5126 11.9268 15.9874 11.9268 16.2803 12.2197C16.5732 12.5126 16.5732 12.9874 16.2803 13.2803L12.5303 17.0303C12.2374 17.3232 11.7626 17.3232 11.4697 17.0303L7.71967 13.2803C7.42678 12.9874 7.42678 12.5126 7.71967 12.2197C8.01256 11.9268 8.48744 11.9268 8.78033 12.2197L11.25 14.6893V2.25C11.25 1.83579 11.5858 1.5 12 1.5ZM6.375 9C6.07663 9 5.79048 9.11853 5.5795 9.3295C5.36853 9.54048 5.25 9.82663 5.25 10.125V19.875C5.25 20.1734 5.36853 20.4595 5.5795 20.6705C5.79048 20.8815 6.07663 21 6.375 21H17.625C17.9234 21 18.2095 20.8815 18.4205 20.6705C18.6315 20.4595 18.75 20.1734 18.75 19.875V10.125C18.75 9.82663 18.6315 9.54048 18.4205 9.3295C18.2095 9.11853 17.9234 9 17.625 9H15.75C15.3358 9 15 8.66421 15 8.25C15 7.83579 15.3358 7.5 15.75 7.5H17.625C18.3212 7.5 18.9889 7.77656 19.4812 8.26884C19.9734 8.76113 20.25 9.42881 20.25 10.125V19.875C20.25 20.5712 19.9734 21.2389 19.4812 21.7312C18.9889 22.2234 18.3212 22.5 17.625 22.5H6.375C5.67881 22.5 5.01113 22.2234 4.51884 21.7312C4.02656 21.2389 3.75 20.5712 3.75 19.875V10.125C3.75 9.42881 4.02656 8.76113 4.51884 8.26884C5.01113 7.77656 5.67881 7.5 6.375 7.5H8.25C8.66421 7.5 9 7.83579 9 8.25C9 8.66421 8.66421 9 8.25 9H6.375Z", fill: "currentColor" })), x2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.018 11.165C4.068 6.793 8.022 4.5 11.984 4.5c4.653 0 8.661 3.031 11.026 6.684l.001.001a1.508 1.508 0 0 1 .001 1.63c-2.363 3.7-6.345 6.685-11.028 6.685-4.733 0-8.638-2.98-10.995-6.668a1.5 1.5 0 0 1 .026-1.664l.003-.003Zm1.232.855.002.003C4.43 15.43 7.918 18 11.984 18c4.02 0 7.585-2.58 9.764-5.993l.002-.003v-.007C19.562 8.62 15.969 6 11.984 6 8.64 6 5.1 7.936 2.25 12.02Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-4.5 3a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Z", fill: "currentColor" })), E2 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 50, height: 21, viewBox: "0 0 50 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M49 15.0351L43.1538 14.2215L36.8641 10.7635L30.9472 13.2807L24.7887 7.98364L18.8113 10.7635L12.834 11.614L6.79623 3.10526L0.999999 1", stroke: "#FC6232", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ t.createElement("path", { d: "M43.1538 14.2215L49 15.0351V21H1V1L6.79623 3.10526L12.834 11.614L18.8113 10.7635L24.7887 7.98364L30.9472 13.2807L36.8641 10.7635L43.1538 14.2215Z", fill: "url(#paint0_linear_446_3221)" }), /* @__PURE__ */ t.createElement("defs", null, /* @__PURE__ */ t.createElement("linearGradient", { id: "paint0_linear_446_3221", x1: 25, y1: -29.1754, x2: 25, y2: 19.2456, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ t.createElement("stop", { stopColor: "#FC6232" }), /* @__PURE__ */ t.createElement("stop", { offset: 1, stopColor: "#FC6232", stopOpacity: 0 })))), y2 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 50, height: 21, viewBox: "0 0 50 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M1 15.0351L6.84615 14.2215L13.1359 10.7635L19.0528 13.2807L25.2113 7.98364L31.1887 10.7635L37.166 11.614L43.2038 3.10526L49 1", stroke: "#35B652", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ t.createElement("path", { d: "M6.84615 14.2215L1 15.0351V21H49V1L43.2038 3.10526L37.166 11.614L31.1887 10.7635L25.2113 7.98364L19.0528 13.2807L13.1359 10.7635L6.84615 14.2215Z", fill: "url(#paint0_linear_446_3212)" }), /* @__PURE__ */ t.createElement("defs", null, /* @__PURE__ */ t.createElement("linearGradient", { id: "paint0_linear_446_3212", x1: 25, y1: -29.1754, x2: 25, y2: 19.2456, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ t.createElement("stop", { stopColor: "#42E466" }), /* @__PURE__ */ t.createElement("stop", { offset: 1, stopColor: "#42E466", stopOpacity: 0 })))), M2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M5.25 11a1 1 0 1 0 0 2h13.5a1 1 0 1 0 0-2H5.25Z", fill: "currentColor" })), L2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19.5 14.25a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5ZM9.75 12a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0Zm-7.5 0a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0Z", fill: "currentColor" })), Z2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 3a.75.75 0 0 1 .75-.75H21a.75.75 0 0 1 .75.75v5.25a.75.75 0 0 1-1.5 0V4.81l-9.22 9.22a.75.75 0 1 1-1.06-1.06l9.22-9.22h-3.44A.75.75 0 0 1 15 3ZM4.875 6.75A1.125 1.125 0 0 0 3.75 7.875v11.25a1.125 1.125 0 0 0 1.125 1.125h11.25a1.126 1.126 0 0 0 1.125-1.125V10.5a.75.75 0 0 1 1.5 0v8.625a2.625 2.625 0 0 1-2.625 2.625H4.875a2.625 2.625 0 0 1-2.625-2.625V7.875A2.625 2.625 0 0 1 4.875 5.25h7.85a.75.75 0 0 1 0 1.5h-7.85Z", fill: "currentColor" })), H2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 4.25a1 1 0 0 0-1 1V11H5.25a1 1 0 1 0 0 2H11v5.75a1 1 0 1 0 2 0V13h5.75a1 1 0 1 0 0-2H13V5.25a1 1 0 0 0-1-1Z", fill: "currentColor" })), V2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 4.25a1 1 0 0 0-1 1V11H5.25a1 1 0 1 0 0 2H11v5.75a1 1 0 1 0 2 0V13h5.75a1 1 0 1 0 0-2H13V5.25a1 1 0 0 0-1-1Z", fill: "currentColor" })), R2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M8.31974 3.11884C8.14182 2.96039 7.86052 2.96039 7.6802 3.11884L4.14109 6.26126C4.00645 6.38401 3.96318 6.56926 4.0329 6.73218C4.10263 6.89287 4.27333 7 4.46086 7H11.5391C11.7266 7 11.8973 6.89287 11.967 6.73218C12.0368 6.56926 11.9935 6.38401 11.8588 6.26126L8.31974 3.11884Z", fill: "#1E1E20", fillOpacity: 0.66 }), /* @__PURE__ */ t.createElement("path", { d: "M11.5391 9H4.46086C4.27333 9 4.10263 9.10714 4.0329 9.26786C3.96318 9.4308 4.00645 9.61607 4.14109 9.73884L7.6802 12.8817C7.76916 12.9598 7.88456 13 7.99997 13C8.11538 13 8.23078 12.9598 8.31974 12.8817L11.8588 9.73884C11.9935 9.61607 12.0368 9.4308 11.967 9.26786C11.8973 9.10714 11.7266 9 11.5391 9Z", fill: "#1E1E20", fillOpacity: 0.18 })), S2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M8.31974 3.11884C8.14182 2.96039 7.86052 2.96039 7.6802 3.11884L4.14109 6.26126C4.00645 6.38401 3.96318 6.56926 4.0329 6.73218C4.10263 6.89287 4.27333 7 4.46086 7H11.5391C11.7266 7 11.8973 6.89287 11.967 6.73218C12.0368 6.56926 11.9935 6.38401 11.8588 6.26126L8.31974 3.11884Z", fill: "#1E1E20", fillOpacity: 0.18 }), /* @__PURE__ */ t.createElement("path", { d: "M11.5391 9H4.46086C4.27333 9 4.10263 9.10714 4.0329 9.26786C3.96318 9.4308 4.00645 9.61607 4.14109 9.73884L7.6802 12.8817C7.76916 12.9598 7.88456 13 7.99997 13C8.11538 13 8.23078 12.9598 8.31974 12.8817L11.8588 9.73884C11.9935 9.61607 12.0368 9.4308 11.967 9.26786C11.8973 9.10714 11.7266 9 11.5391 9Z", fill: "#1E1E20", fillOpacity: 0.18 })), k2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M8.31974 3.11884C8.14182 2.96039 7.86052 2.96039 7.6802 3.11884L4.14109 6.26126C4.00645 6.38401 3.96318 6.56926 4.0329 6.73218C4.10263 6.89287 4.27333 7 4.46086 7H11.5391C11.7266 7 11.8973 6.89287 11.967 6.73218C12.0368 6.56926 11.9935 6.38401 11.8588 6.26126L8.31974 3.11884Z", fill: "#1E1E20", fillOpacity: 0.18 }), /* @__PURE__ */ t.createElement("path", { d: "M11.5391 9H4.46086C4.27333 9 4.10263 9.10714 4.0329 9.26786C3.96318 9.4308 4.00645 9.61607 4.14109 9.73884L7.6802 12.8817C7.76916 12.9598 7.88456 13 7.99997 13C8.11538 13 8.23078 12.9598 8.31974 12.8817L11.8588 9.73884C11.9935 9.61607 12.0368 9.4308 11.967 9.26786C11.8973 9.10714 11.7266 9 11.5391 9Z", fill: "#1E1E20", fillOpacity: 0.66 })), B2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.856 3.617A8.114 8.114 0 1 1 14.87 17.11 8.114 8.114 0 0 1 5.856 3.617Zm4.508.133a6.614 6.614 0 0 1 6.613 6.614M10.364 3.75a6.614 6.614 0 1 0 6.613 6.614", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.327 15.327a.75.75 0 0 1 1.06 0l5.143 5.143a.75.75 0 1 1-1.06 1.06l-5.143-5.142a.75.75 0 0 1 0-1.061Z", fill: "currentColor" })), T2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M18 7.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.082 22.5c.557 0 1.091-.22 1.485-.614l11.515-11.512c.267-.268.417-.63.418-1.008V3.6a2.074 2.074 0 0 0-.61-1.481 2.083 2.083 0 0 0-1.486-.619h-5.762c-.378 0-.74.15-1.009.417L2.113 13.434a2.101 2.101 0 0 0 0 2.968l5.485 5.484c.394.394.928.614 1.484.614ZM20.824 3.173l.007.008a.574.574 0 0 1 .169.41v5.743L9.507 20.824a.604.604 0 0 1-.85.001l-5.482-5.482a.603.603 0 0 1 0-.849L14.67 3h5.738a.583.583 0 0 1 .416.173Z", fill: "currentColor" })), A2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 2.25A9.75 9.75 0 0 0 2.25 12c0 5.384 4.365 9.75 9.75 9.75 5.384 0 9.75-4.366 9.75-9.75 0-5.385-4.366-9.75-9.75-9.75Zm4.5 11.25H12a.75.75 0 0 1-.75-.75V6a.75.75 0 1 1 1.5 0v6h3.75a.75.75 0 1 1 0 1.5Z", fill: "currentColor" })), O2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 15.628a.75.75 0 0 1-.75-.715l-.268-5.719V9.16a1.02 1.02 0 1 1 2.036.036l-.269 5.718a.75.75 0 0 1-.749.715Zm-.937 2.056a.937.937 0 1 0 1.874 0 .937.937 0 0 0-1.874 0Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.011 21.668c-.37 0-.74-.093-1.066-.27a2.236 2.236 0 0 1-1.089-1.334 2.236 2.236 0 0 1 .174-1.713l7.99-14.836A2.248 2.248 0 0 1 12 2.332c.829 0 1.588.453 1.981 1.183l7.989 14.836c.176.327.269.696.269 1.067 0 .6-.234 1.165-.659 1.59a2.23 2.23 0 0 1-1.59.66H4.01Zm0-1.5H19.99c.2 0 .389-.078.53-.22a.745.745 0 0 0 .13-.885L12.66 4.227a.734.734 0 0 0-.66-.395.734.734 0 0 0-.66.395L3.35 19.063a.746.746 0 0 0 .305 1.015c.109.059.231.09.355.09Z", fill: "currentColor" })), G2 = (e) => /* @__PURE__ */ t.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M10.0007 14.375C9.89192 14.375 9.78502 14.3465 9.69057 14.2925L4.21947 11.1656C4.17193 11.1381 4.118 11.1237 4.06311 11.1237C4.00821 11.1237 3.95429 11.1382 3.90677 11.1657C3.85925 11.1932 3.81981 11.2327 3.79242 11.2803C3.76502 11.3278 3.75064 11.3818 3.75072 11.4367V14.375C3.75063 14.4865 3.78039 14.5961 3.83692 14.6922C3.89345 14.7884 3.97469 14.8677 4.07221 14.9218L9.69721 18.0468C9.79005 18.0984 9.89451 18.1255 10.0007 18.1255C10.1069 18.1255 10.2114 18.0984 10.3042 18.0468L15.9292 14.9218C16.0267 14.8677 16.108 14.7884 16.1645 14.6922C16.2211 14.5961 16.2508 14.4865 16.2507 14.375V11.4367C16.2508 11.3818 16.2364 11.3278 16.209 11.2803C16.1816 11.2327 16.1422 11.1932 16.0947 11.1657C16.0472 11.1382 15.9932 11.1237 15.9383 11.1237C15.8834 11.1237 15.8295 11.1381 15.782 11.1656L10.3109 14.2925C10.2164 14.3465 10.1095 14.375 10.0007 14.375Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { d: "M19.3726 7.44137C19.3726 7.44137 19.3726 7.43825 19.3726 7.43708C19.3625 7.33801 19.3289 7.24279 19.2745 7.15935C19.2201 7.07591 19.1466 7.00667 19.0601 6.95739L10.3101 1.95739C10.2156 1.9034 10.1087 1.875 9.99994 1.875C9.89115 1.875 9.78424 1.9034 9.68978 1.95739L0.939784 6.95739C0.844154 7.01206 0.764673 7.09104 0.709394 7.18633C0.654114 7.28161 0.625 7.38981 0.625 7.49997C0.625 7.61012 0.654114 7.71832 0.709394 7.81361C0.764673 7.90889 0.844154 7.98787 0.939784 8.04254L9.68978 13.0425C9.78424 13.0965 9.89115 13.1249 9.99994 13.1249C10.1087 13.1249 10.2156 13.0965 10.3101 13.0425L18.0085 8.64372C18.0204 8.63685 18.0339 8.63323 18.0477 8.63325C18.0614 8.63326 18.0749 8.6369 18.0868 8.64379C18.0987 8.65069 18.1085 8.66059 18.1154 8.67251C18.1222 8.68443 18.1258 8.69794 18.1257 8.71169V14.3574C18.1257 14.6937 18.3843 14.9824 18.7206 14.9992C18.8051 15.0033 18.8896 14.9901 18.9689 14.9606C19.0482 14.9311 19.1206 14.8857 19.1819 14.8274C19.2431 14.769 19.2919 14.6988 19.3252 14.6211C19.3585 14.5433 19.3757 14.4596 19.3757 14.375V7.49997C19.3757 7.48039 19.3746 7.46084 19.3726 7.44137Z", fill: "currentColor" }));
function u1() {
  for (var e = 0, r, l, n = ""; e < arguments.length; )
    (r = arguments[e++]) && (l = a1(r)) && (n && (n += " "), n += l);
  return n;
}
function a1(e) {
  if (typeof e == "string")
    return e;
  for (var r, l = "", n = 0; n < e.length; n++)
    e[n] && (r = a1(e[n])) && (l && (l += " "), l += r);
  return l;
}
function j() {
  return j = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var l = arguments[r];
      for (var n in l)
        Object.prototype.hasOwnProperty.call(l, n) && (e[n] = l[n]);
    }
    return e;
  }, j.apply(this, arguments);
}
var P = "-";
function p1(e) {
  var r = g1(e);
  function l(a) {
    var s = a.split(P);
    return s[0] === "" && s.length !== 1 && s.shift(), i1(s, r) || v1(a);
  }
  function n(a) {
    return e.conflictingClassGroups[a] || [];
  }
  return {
    getClassGroupId: l,
    getConflictingClassGroupIds: n
  };
}
function i1(e, r) {
  var l;
  if (e.length === 0)
    return r.classGroupId;
  var n = e[0], a = r.nextPart.get(n), s = a ? i1(e.slice(1), a) : void 0;
  if (s)
    return s;
  if (r.validators.length !== 0) {
    var i = e.join(P);
    return (l = r.validators.find(function(o) {
      var d = o.validator;
      return d(i);
    })) == null ? void 0 : l.classGroupId;
  }
}
var l1 = /^\[(.+)\]$/;
function v1(e) {
  if (l1.test(e)) {
    var r = l1.exec(e)[1], l = r == null ? void 0 : r.substring(0, r.indexOf(":"));
    if (l)
      return "arbitrary.." + l;
  }
}
function g1(e) {
  var r = e.theme, l = e.prefix, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, a = m1(Object.entries(e.classGroups), l);
  return a.forEach(function(s) {
    var i = s[0], o = s[1];
    D(o, n, i, r);
  }), n;
}
function D(e, r, l, n) {
  e.forEach(function(a) {
    if (typeof a == "string") {
      var s = a === "" ? r : n1(r, a);
      s.classGroupId = l;
      return;
    }
    if (typeof a == "function") {
      if (f1(a)) {
        D(a(n), r, l, n);
        return;
      }
      r.validators.push({
        validator: a,
        classGroupId: l
      });
      return;
    }
    Object.entries(a).forEach(function(i) {
      var o = i[0], d = i[1];
      D(d, n1(r, o), l, n);
    });
  });
}
function n1(e, r) {
  var l = e;
  return r.split(P).forEach(function(n) {
    l.nextPart.has(n) || l.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), l = l.nextPart.get(n);
  }), l;
}
function f1(e) {
  return e.isThemeGetter;
}
function m1(e, r) {
  return r ? e.map(function(l) {
    var n = l[0], a = l[1], s = a.map(function(i) {
      return typeof i == "string" ? r + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(function(o) {
        var d = o[0], u = o[1];
        return [r + d, u];
      })) : i;
    });
    return [n, s];
  }) : e;
}
function w1(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var r = 0, l = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  function a(s, i) {
    l.set(s, i), r++, r > e && (r = 0, n = l, l = /* @__PURE__ */ new Map());
  }
  return {
    get: function(i) {
      var o = l.get(i);
      if (o !== void 0)
        return o;
      if ((o = n.get(i)) !== void 0)
        return a(i, o), o;
    },
    set: function(i, o) {
      l.has(i) ? l.set(i, o) : a(i, o);
    }
  };
}
var s1 = "!";
function h1(e) {
  var r = e.separator || ":";
  return function(n) {
    for (var a = 0, s = [], i = 0, o = 0; o < n.length; o++) {
      var d = n[o];
      a === 0 && d === r[0] && (r.length === 1 || n.slice(o, o + r.length) === r) && (s.push(n.slice(i, o)), i = o + r.length), d === "[" ? a++ : d === "]" && a--;
    }
    var u = s.length === 0 ? n : n.substring(i), g = u.startsWith(s1), f = g ? u.substring(1) : u;
    return {
      modifiers: s,
      hasImportantModifier: g,
      baseClassName: f
    };
  };
}
function b1(e) {
  if (e.length <= 1)
    return e;
  var r = [], l = [];
  return e.forEach(function(n) {
    var a = n[0] === "[";
    a ? (r.push.apply(r, l.sort().concat([n])), l = []) : l.push(n);
  }), r.push.apply(r, l.sort()), r;
}
function x1(e) {
  return j({
    cache: w1(e.cacheSize),
    splitModifiers: h1(e)
  }, p1(e));
}
var E1 = /\s+/;
function y1(e, r) {
  var l = r.splitModifiers, n = r.getClassGroupId, a = r.getConflictingClassGroupIds, s = /* @__PURE__ */ new Set();
  return e.trim().split(E1).map(function(i) {
    var o = l(i), d = o.modifiers, u = o.hasImportantModifier, g = o.baseClassName, f = n(g);
    if (!f)
      return {
        isTailwindClass: !1,
        originalClassName: i
      };
    var b = b1(d).join(":"), y = u ? b + s1 : b;
    return {
      isTailwindClass: !0,
      modifierId: y,
      classGroupId: f,
      originalClassName: i
    };
  }).reverse().filter(function(i) {
    if (!i.isTailwindClass)
      return !0;
    var o = i.modifierId, d = i.classGroupId, u = o + d;
    return s.has(u) ? !1 : (s.add(u), a(d).forEach(function(g) {
      return s.add(o + g);
    }), !0);
  }).reverse().map(function(i) {
    return i.originalClassName;
  }).join(" ");
}
function M1() {
  for (var e = arguments.length, r = new Array(e), l = 0; l < e; l++)
    r[l] = arguments[l];
  var n, a, s, i = o;
  function o(u) {
    var g = r[0], f = r.slice(1), b = f.reduce(function(y, h) {
      return h(y);
    }, g());
    return n = x1(b), a = n.cache.get, s = n.cache.set, i = d, d(u);
  }
  function d(u) {
    var g = a(u);
    if (g)
      return g;
    var f = y1(u, n);
    return s(u, f), f;
  }
  return function() {
    return i(u1.apply(null, arguments));
  };
}
function C(e) {
  var r = function(n) {
    return n[e] || [];
  };
  return r.isThemeGetter = !0, r;
}
var C1 = /^\[(?:([a-z-]+):)?(.+)\]$/i, L1 = /^\d+\/\d+$/, Z1 = /* @__PURE__ */ new Set(["px", "full", "screen"]), H1 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, V1 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))/, R1 = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function w(e) {
  return B(e) || Z1.has(e) || L1.test(e) || Z(e);
}
function Z(e) {
  return H(e, "length", A1);
}
function S1(e) {
  return H(e, "size", c1);
}
function k1(e) {
  return H(e, "position", c1);
}
function B1(e) {
  return H(e, "url", O1);
}
function F(e) {
  return H(e, "number", B);
}
function B(e) {
  return !Number.isNaN(Number(e));
}
function S(e) {
  return o1(e) || H(e, "number", o1);
}
function p(e) {
  return C1.test(e);
}
function k() {
  return !0;
}
function E(e) {
  return H1.test(e);
}
function T1(e) {
  return H(e, "", G1);
}
function H(e, r, l) {
  var n = C1.exec(e);
  return n ? n[1] ? n[1] === r : l(n[2]) : !1;
}
function A1(e) {
  return V1.test(e);
}
function c1() {
  return !1;
}
function O1(e) {
  return e.startsWith("url(");
}
function o1(e) {
  return Number.isInteger(Number(e));
}
function G1(e) {
  return R1.test(e);
}
function z1() {
  var e = C("colors"), r = C("spacing"), l = C("blur"), n = C("brightness"), a = C("borderColor"), s = C("borderRadius"), i = C("borderSpacing"), o = C("borderWidth"), d = C("contrast"), u = C("grayscale"), g = C("hueRotate"), f = C("invert"), b = C("gap"), y = C("gradientColorStops"), h = C("inset"), M = C("margin"), x = C("opacity"), L = C("padding"), $ = C("saturate"), G = C("scale"), q = C("sepia"), J = C("skew"), X = C("space"), K = C("translate"), z = function() {
    return ["auto", "contain", "none"];
  }, I = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, Q = function() {
    return ["auto", r];
  }, Y = function() {
    return ["", w];
  }, T = function() {
    return ["auto", B, p];
  }, e1 = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, A = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, t1 = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, N = function() {
    return ["start", "end", "center", "between", "around", "evenly"];
  }, V = function() {
    return ["", "0", p];
  }, r1 = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, R = function() {
    return [B, F];
  }, O = function() {
    return [B, p];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [k],
      spacing: [w],
      blur: ["none", "", E, Z],
      brightness: R(),
      borderColor: [e],
      borderRadius: ["none", "", "full", E, Z],
      borderSpacing: [r],
      borderWidth: Y(),
      contrast: R(),
      grayscale: V(),
      hueRotate: O(),
      invert: V(),
      gap: [r],
      gradientColorStops: [e],
      inset: Q(),
      margin: Q(),
      opacity: R(),
      padding: [r],
      saturate: R(),
      scale: R(),
      sepia: V(),
      skew: O(),
      space: [r],
      translate: [r]
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", p]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [E]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": r1()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": r1()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(e1(), [p])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: I()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": I()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": I()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: z()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": z()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": z()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [h]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [h]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [h]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [h]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [h]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [h]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [h]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", S]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [r]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", p]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: V()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: V()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", S]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [k]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: [S]
        }, p]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": T()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": T()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [k]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [S]
        }, p]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": T()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": T()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", p]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", p]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [b]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [b]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [b]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: N()
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: [].concat(N(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(N(), ["baseline", "stretch"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [L]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [L]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [L]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [L]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [L]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [L]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [L]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [M]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [M]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [M]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [M]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [M]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [M]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [M]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [X]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [X]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", r]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", w]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [E]
        }, E, Z]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [r, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", w]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [r, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", E, Z]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", F]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [k]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Z]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", w]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", p]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [x]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [x]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(A(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", w]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", w]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: [r]
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Z]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", p]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [x]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(e1(), [k1])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", S1]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, B1]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [y]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [y]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [y]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [s]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [s]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [s]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [s]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [s]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [s]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [s]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [s]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [s]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [o]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [o]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [o]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [o]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [o]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [o]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [o]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [x]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(A(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [o]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [o]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [x]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: A()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(A())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [w]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [w]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: Y()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [x]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [w]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", E, T1]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [k]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [x]
      }],
      /**
       * Mix Beldn Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": t1()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": t1()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [l]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [d]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", E, p]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [g]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [$]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [q]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [l]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [d]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [g]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [x]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [$]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [q]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", p]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: O()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", p]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: O()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", p]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [G]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [G]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [G]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [S, p]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [K]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [K]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [J]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [J]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", p]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", p]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": [r]
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": [r]
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": [r]
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": [r]
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": [r]
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": [r]
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": [r]
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": [r]
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": [r]
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": [r]
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": [r]
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": [r]
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": [r]
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": [r]
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", p]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [w, F]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    }
  };
}
var U = /* @__PURE__ */ M1(z1);
const I1 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12 1.5C13.4062 1.5 14.6803 2.04234 15.5925 3.02719C16.5159 4.02422 16.9659 5.36625 16.8595 6.80531C16.6481 9.66984 14.4717 12 12 12C9.52827 12 7.34812 9.66938 7.13999 6.80438C7.03499 5.35219 7.48218 4.00734 8.39999 3.01781C9.30796 2.03906 10.5862 1.5 12 1.5Z" }), /* @__PURE__ */ t.createElement("path", { d: "M3.12391 22.3672C3.32014 22.4574 3.53402 22.5028 3.74999 22.5H20.25C20.466 22.5028 20.6799 22.4573 20.8761 22.367C21.0724 22.2766 21.246 22.1437 21.3844 21.9778C21.6891 21.6136 21.8119 21.1162 21.7209 20.6133C21.3253 18.4186 20.0906 16.575 18.15 15.2812C16.4259 14.1328 14.242 13.5 12 13.5C9.75796 13.5 7.57406 14.1323 5.84999 15.2812C3.90937 16.5755 2.67468 18.4191 2.27906 20.6138C2.18812 21.1167 2.31093 21.6141 2.61562 21.9783C2.75404 22.1441 2.92768 22.2769 3.12391 22.3672Z", fill: "currentColor" })), N1 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.12737 6.80438C7.33596 9.66938 9.52221 12 12.0005 12C14.475 12 16.6608 9.66984 16.8732 6.80531C16.98 5.36625 16.5286 4.02469 15.6024 3.02719C14.6878 2.04234 13.418 1.5 12.0005 1.5C10.583 1.5 9.30143 2.03906 8.39065 3.01781C7.47049 4.00781 7.0219 5.35219 7.12737 6.80438ZM9.4894 4.03969C10.1128 3.36937 11.0044 3 12.0005 3C12.9867 3 13.8755 3.37219 14.5031 4.04813C15.1425 4.73672 15.4528 5.67656 15.3774 6.69469C15.2246 8.75719 13.681 10.5 12.0005 10.5C10.32 10.5 8.77362 8.75766 8.62362 6.69562C8.54862 5.66391 8.85612 4.72078 9.4894 4.03969Z" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.61612 21.9783C2.89737 22.3148 3.30003 22.5 3.75049 22.5H20.25C20.7005 22.5 21.1036 22.3148 21.3849 21.9783C21.6896 21.6136 21.8119 21.1163 21.7214 20.6138C21.3253 18.4191 20.0902 16.5755 18.1496 15.2817C16.426 14.1328 14.2416 13.5 12 13.5C9.75846 13.5 7.57409 14.1328 5.85049 15.2817C3.90987 16.5755 2.67471 18.4191 2.27909 20.6138C2.18862 21.1163 2.31143 21.6136 2.61612 21.9783ZM20.2416 21H3.75987C3.75284 20.978 3.74534 20.9372 3.75565 20.88C4.07721 19.0964 5.08971 17.5922 6.68299 16.53C8.16284 15.5433 10.0519 15 12.0005 15C13.9491 15 15.8377 15.5433 17.318 16.53C18.9113 17.5922 19.9238 19.0964 20.2458 20.88C20.2561 20.9372 20.2491 20.9784 20.2416 21Z", fill: "currentColor" })), F1 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19.5 21.75H4.5C3.26203 21.7467 2.25328 20.738 2.25 19.5019V4.5C2.25328 3.26203 3.26203 2.25328 4.49813 2.25H19.5C20.738 2.25328 21.7467 3.26203 21.75 4.49813V19.5C21.7467 20.738 20.738 21.7467 19.5019 21.75H19.5Z" }), /* @__PURE__ */ t.createElement("path", { d: "M15.0019 14.3198C14.783 14.3198 14.5744 14.2242 14.4319 14.0573L12.9258 12.2967C12.6562 11.9822 12.6933 11.5087 13.0083 11.2392C13.3228 10.9697 13.7963 11.0067 14.0658 11.3217L14.9827 12.3933L17.9311 8.70796C18.1898 8.38452 18.6619 8.33202 18.9853 8.59077C19.3087 8.84952 19.3612 9.32155 19.1025 9.64499L15.5878 14.0381C15.4481 14.2125 15.2381 14.3156 15.0145 14.3194C15.0103 14.3194 15.0061 14.3194 15.0023 14.3194L15.0019 14.3198Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { d: "M10.1002 8.25937H6.23438C5.82 8.25937 5.48438 7.92374 5.48438 7.50937C5.48438 7.09499 5.82 6.75937 6.23438 6.75937H10.1002C10.5145 6.75937 10.8502 7.09499 10.8502 7.50937C10.8502 7.92374 10.5145 8.25937 10.1002 8.25937Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { d: "M10.1002 12.7523H6.23438C5.82 12.7523 5.48438 12.4167 5.48438 12.0023C5.48438 11.588 5.82 11.2523 6.23438 11.2523H10.1002C10.5145 11.2523 10.8502 11.588 10.8502 12.0023C10.8502 12.4167 10.5145 12.7523 10.1002 12.7523Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { d: "M10.1002 17.2453H6.23438C5.82 17.2453 5.48438 16.9097 5.48438 16.4953C5.48438 16.0809 5.82 15.7453 6.23438 15.7453H10.1002C10.5145 15.7453 10.8502 16.0809 10.8502 16.4953C10.8502 16.9097 10.5145 17.2453 10.1002 17.2453Z", fill: "currentColor" })), j1 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M19.5 21.75H4.5C3.26203 21.7467 2.25328 20.738 2.25 19.5019V4.5C2.25328 3.26203 3.26203 2.25328 4.49813 2.25H19.5C20.738 2.25328 21.7467 3.26203 21.75 4.49813V19.5C21.7467 20.738 20.738 21.7467 19.5019 21.75H19.5ZM19.4981 3.75H4.5C4.08844 3.75094 3.75094 4.08844 3.75 4.50187V19.5C3.75094 19.9116 4.08844 20.2491 4.50187 20.25H19.4986C19.9116 20.2486 20.2486 19.9111 20.25 19.4981V4.5C20.2491 4.08844 19.9116 3.75094 19.4981 3.75Z" }), /* @__PURE__ */ t.createElement("path", { d: "M15.0019 14.3198C14.783 14.3198 14.5744 14.2242 14.4319 14.0573L12.9258 12.2967C12.6562 11.9822 12.6933 11.5087 13.0083 11.2392C13.3228 10.9697 13.7963 11.0067 14.0658 11.3217L14.9827 12.3933L17.9311 8.70796C18.1898 8.38452 18.6619 8.33202 18.9853 8.59077C19.3087 8.84952 19.3612 9.32155 19.1025 9.64499L15.5878 14.0381C15.4481 14.2125 15.2381 14.3156 15.0145 14.3194C15.0103 14.3194 15.0061 14.3194 15.0023 14.3194L15.0019 14.3198Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { d: "M10.1002 8.25937H6.23438C5.82 8.25937 5.48438 7.92374 5.48438 7.50937C5.48438 7.09499 5.82 6.75937 6.23438 6.75937H10.1002C10.5145 6.75937 10.8502 7.09499 10.8502 7.50937C10.8502 7.92374 10.5145 8.25937 10.1002 8.25937Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { d: "M10.1002 12.7523H6.23438C5.82 12.7523 5.48438 12.4167 5.48438 12.0023C5.48438 11.588 5.82 11.2523 6.23438 11.2523H10.1002C10.5145 11.2523 10.8502 11.588 10.8502 12.0023C10.8502 12.4167 10.5145 12.7523 10.1002 12.7523Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { d: "M10.1002 17.2453H6.23438C5.82 17.2453 5.48438 16.9097 5.48438 16.4953C5.48438 16.0809 5.82 15.7453 6.23438 15.7453H10.1002C10.5145 15.7453 10.8502 16.0809 10.8502 16.4953C10.8502 16.9097 10.5145 17.2453 10.1002 17.2453Z", fill: "currentColor" })), D1 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M10.65 2.94001L6.93 9.02001C6.52 9.68001 7 10.54 7.78 10.54H15.21C15.99 10.54 16.47 9.68001 16.06 9.02001L12.35 2.94001C11.96 2.30001 11.04 2.30001 10.65 2.94001Z" }), /* @__PURE__ */ t.createElement("path", { d: "M17 21.54C19.4853 21.54 21.5 19.5253 21.5 17.04C21.5 14.5547 19.4853 12.54 17 12.54C14.5147 12.54 12.5 14.5547 12.5 17.04C12.5 19.5253 14.5147 21.54 17 21.54Z" }), /* @__PURE__ */ t.createElement("path", { d: "M3.5 21.04H9.5C10.05 21.04 10.5 20.59 10.5 20.04V14.04C10.5 13.49 10.05 13.04 9.5 13.04H3.5C2.95 13.04 2.5 13.49 2.5 14.04V20.04C2.5 20.59 2.95 21.04 3.5 21.04Z", fill: "currentColor" })), W1 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M11.2898 3.33144L11.2905 3.33028C11.3882 3.16991 11.6118 3.16991 11.7095 3.33028L11.7098 3.33067L15.4198 9.41067L15.4198 9.41068L15.4229 9.41577C15.5202 9.57244 15.4062 9.79001 15.21 9.79001H7.78C7.58377 9.79001 7.46975 9.57244 7.56708 9.41577L7.56975 9.41143L11.2898 3.33144ZM20.75 17.04C20.75 19.1111 19.0711 20.79 17 20.79C14.9289 20.79 13.25 19.1111 13.25 17.04C13.25 14.9689 14.9289 13.29 17 13.29C19.0711 13.29 20.75 14.9689 20.75 17.04Z", strokeWidth: 1.5 }), /* @__PURE__ */ t.createElement("path", { d: "M9.5 20.29H3.5C3.36421 20.29 3.25 20.1758 3.25 20.04V14.04C3.25 13.9042 3.36421 13.79 3.5 13.79H9.5C9.63579 13.79 9.75 13.9042 9.75 14.04V20.04C9.75 20.1758 9.63579 20.29 9.5 20.29Z", stroke: "currentColor", strokeWidth: 1.5 })), P1 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.75 11.21C10.75 11.62 10.41 11.96 10 11.96H5.75C5.34 11.96 5 11.62 5 11.21C5 10.8 5.34 10.46 5.75 10.46H10C10.41 10.46 10.75 10.8 10.75 11.21Z" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 7.46002C17 7.87002 16.66 8.21002 16.25 8.21002H5.75C5.34 8.21002 5 7.87002 5 7.46002C5 7.05002 5.34 6.71002 5.75 6.71002H16.25C16.66 6.71002 17 7.05002 17 7.46002Z" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.62 3.88C21.06 3.32 20.29 3 19.5 3H4.5C3.7 3 2.94 3.32 2.38 3.88C1.82 4.44 1.5 5.21 1.5 6V16.5C1.5 17.3 1.82 18.06 2.38 18.62C2.94 19.18 3.71 19.5 4.5 19.5H13.16L13.23 18H4.5C4.1 18 3.72 17.84 3.44 17.56C3.16 17.28 3 16.9 3 16.5V6C3 5.6 3.16 5.22 3.44 4.94C3.72 4.66 4.1 4.5 4.5 4.5H19.5C19.9 4.5 20.28 4.66 20.56 4.94C20.84 5.22 21 5.6 21 6V16.5C21 16.9 20.84 17.28 20.56 17.56C20.28 17.84 19.9 18 19.5 18H19.47L19.52 19.5C20.31 19.5 21.06 19.18 21.61 18.62C22.17 18.06 22.49 17.29 22.49 16.5V6C22.49 5.2 22.17 4.44 21.61 3.88H21.62Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { d: "M18.32 17.64C18.24 17.69 18.15 17.74 18.06 17.78C17.95 17.83 17.84 17.88 17.73 17.93C16.63 18.36 15.4 18.29 14.36 17.74C14.32 17.72 14.26 17.74 14.24 17.78C14.24 17.79 14.23 17.81 14.23 17.82L14.08 21.22C14.08 21.35 14.13 21.48 14.24 21.55C14.35 21.62 14.49 21.63 14.61 21.57L16.21 20.77C16.32 20.71 16.46 20.71 16.57 20.78L18.03 21.71C18.14 21.78 18.28 21.79 18.39 21.73C18.51 21.66 18.6 21.52 18.59 21.38L18.46 17.72C18.46 17.67 18.42 17.63 18.36 17.63C18.34 17.63 18.33 17.63 18.32 17.64Z" }), /* @__PURE__ */ t.createElement("path", { d: "M19.22 12.68C18.4 11.05 16.41 10.38 14.78 11.2C13.15 12.02 12.48 14.01 13.3 15.64C14.12 17.27 16.11 17.94 17.74 17.12C19.37 16.3 20.04 14.31 19.22 12.68Z" })), U1 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M12.6094 15.7317C12.4116 15.7464 12.2119 15.7537 12.0103 15.7537C11.7652 15.7537 11.5228 15.7425 11.2833 15.7214C10.0983 15.6164 8.95004 15.2565 7.91712 14.6663C6.88419 14.0762 5.99101 13.2698 5.29875 12.3023C5.28052 12.2763 5.25598 12.2554 5.22743 12.2415C5.19888 12.2275 5.16726 12.2211 5.13554 12.2227C5.10382 12.2244 5.07303 12.234 5.04607 12.2508C5.01911 12.2676 4.99686 12.291 4.98141 12.3187L1.60641 18.3844C1.47797 18.6188 1.45781 18.9 1.59328 19.1287C1.6638 19.2422 1.76204 19.3358 1.87874 19.4007C1.99544 19.4657 2.12676 19.4998 2.26031 19.5H5.91656C6.04393 19.4953 6.17024 19.5247 6.28247 19.585C6.3947 19.6454 6.48878 19.7347 6.555 19.8436L8.36719 22.875C8.4335 22.9875 8.5276 23.081 8.64046 23.1467C8.75332 23.2124 8.88116 23.2479 9.01172 23.25C9.29016 23.2345 9.57844 23.0536 9.69422 22.8L12.7931 15.9961C12.8065 15.9665 12.812 15.934 12.809 15.9017C12.8061 15.8694 12.7948 15.8384 12.7763 15.8118C12.7578 15.7851 12.7326 15.7637 12.7034 15.7497C12.6741 15.7357 12.6417 15.7295 12.6094 15.7317Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { d: "M22.3894 18.3694L19.0364 12.3145C19.0209 12.2871 18.9987 12.2639 18.9719 12.2473C18.9451 12.2307 18.9146 12.2211 18.8831 12.2194C18.8516 12.2177 18.8202 12.224 18.7917 12.2377C18.7633 12.2514 18.7388 12.272 18.7205 12.2977C17.7984 13.5896 16.5241 14.589 15.0497 15.1767C14.8687 15.2481 14.7222 15.3866 14.6409 15.5634L12.9131 19.365C12.8909 19.4135 12.8794 19.4663 12.8794 19.5197C12.8794 19.5731 12.8909 19.6259 12.9131 19.6744L14.332 22.7958C14.4469 23.0494 14.7347 23.2345 15.0127 23.25C15.1433 23.2468 15.271 23.2101 15.3834 23.1435C15.4958 23.0768 15.5893 22.9825 15.6548 22.8694L17.4609 19.8422C17.5964 19.6149 17.842 19.4986 18.1069 19.5H21.7992C22.1119 19.5 22.3486 19.3369 22.4555 19.0313C22.493 18.9227 22.5066 18.8073 22.4952 18.6931C22.4838 18.5788 22.4477 18.4683 22.3894 18.3694Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { d: "M12.0122 9.75C13.2551 9.75 14.2627 8.74264 14.2627 7.5C14.2627 6.25736 13.2551 5.25 12.0122 5.25C10.7693 5.25 9.76172 6.25736 9.76172 7.5C9.76172 8.74264 10.7693 9.75 12.0122 9.75Z" }), /* @__PURE__ */ t.createElement("path", { d: "M12.0122 0.75C8.28938 0.75 5.26219 3.77766 5.26219 7.5C5.26219 11.2223 8.29079 14.25 12.0122 14.25C15.7336 14.25 18.7622 11.2219 18.7622 7.5C18.7622 3.77812 15.7345 0.75 12.0122 0.75ZM12.0122 11.25C11.2705 11.25 10.5455 11.0301 9.9288 10.618C9.31212 10.206 8.83147 9.62029 8.54764 8.93506C8.26381 8.24984 8.18955 7.49584 8.33425 6.76841C8.47894 6.04098 8.83609 5.3728 9.36054 4.84835C9.88499 4.3239 10.5532 3.96675 11.2806 3.82206C12.008 3.67736 12.762 3.75162 13.4473 4.03545C14.1325 4.31928 14.7181 4.79993 15.1302 5.41661C15.5423 6.0333 15.7622 6.75832 15.7622 7.5C15.761 8.49418 15.3655 9.44729 14.6625 10.1503C13.9595 10.8533 13.0064 11.2488 12.0122 11.25Z" })), _1 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.09781 10.0235C7.4599 10.2246 7.59037 10.6812 7.38922 11.0433L3.52804 17.9938L6.31777 17.9804C6.31783 17.9804 6.31788 17.9803 6.31794 17.9803C6.57879 17.9791 6.83546 18.0458 7.06263 18.174C7.28985 18.3023 7.47968 18.4876 7.6134 18.7116L8.91011 20.8854L12.4577 13.0809C12.6291 12.7038 13.0737 12.5371 13.4508 12.7085C13.8279 12.8799 13.9946 13.3246 13.8232 13.7016L9.68277 22.8104C9.56729 23.0644 9.32032 23.2334 9.04169 23.2489C8.76306 23.2644 8.49886 23.1239 8.3559 22.8843L6.32535 19.4803L2.25363 19.5C1.98725 19.5013 1.74017 19.3612 1.60452 19.1319C1.46887 18.9027 1.46501 18.6187 1.59437 18.3858L6.07797 10.3149C6.27912 9.95278 6.73572 9.82231 7.09781 10.0235Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.8182 9.8439C17.1806 9.64324 17.637 9.77432 17.8377 10.1367L22.4061 18.3867C22.5351 18.6196 22.5309 18.9034 22.3952 19.1324C22.2595 19.3614 22.0126 19.5013 21.7464 19.5L17.6746 19.4803L15.6441 22.8842C15.5011 23.1239 15.2369 23.2644 14.9583 23.2489C14.6797 23.2333 14.4327 23.0644 14.3172 22.8104L11.3172 16.2104C11.1458 15.8333 11.3126 15.3886 11.6896 15.2172C12.0667 15.0458 12.5114 15.2126 12.6828 15.5897L15.0899 20.8853L16.3865 18.7117L16.3866 18.7116C16.5203 18.4875 16.7102 18.3023 16.9374 18.174C17.1645 18.0458 17.4212 17.979 17.6821 17.9803C17.6821 17.9803 17.6822 17.9803 17.6822 17.9803L20.474 17.9938L16.5254 10.8633C16.3248 10.501 16.4559 10.0446 16.8182 9.8439Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.25C9.1005 2.25 6.75 4.6005 6.75 7.5C6.75 10.3995 9.1005 12.75 12 12.75C14.8995 12.75 17.25 10.3995 17.25 7.5C17.25 4.6005 14.8995 2.25 12 2.25ZM5.25 7.5C5.25 3.77208 8.27208 0.75 12 0.75C15.7279 0.75 18.75 3.77208 18.75 7.5C18.75 11.2279 15.7279 14.25 12 14.25C8.27208 14.25 5.25 11.2279 5.25 7.5Z" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 5.25C10.7574 5.25 9.75 6.25736 9.75 7.5C9.75 8.74264 10.7574 9.75 12 9.75C13.2426 9.75 14.25 8.74264 14.25 7.5C14.25 6.25736 13.2426 5.25 12 5.25ZM8.25 7.5C8.25 5.42893 9.92893 3.75 12 3.75C14.0711 3.75 15.75 5.42893 15.75 7.5C15.75 9.57107 14.0711 11.25 12 11.25C9.92893 11.25 8.25 9.57107 8.25 7.5Z" })), $1 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M22.8075 2.68453C22.5248 2.40422 22.1508 2.25 21.7523 2.25H21.7467C18.5775 2.26406 16.2136 2.66437 14.5205 3.47344C13.4091 4.00453 12.5742 4.70859 12.0005 5.60531C11.4262 4.70906 10.5919 4.00453 9.48047 3.47344C7.78734 2.66437 5.42344 2.26406 2.25047 2.25H2.24203C1.84219 2.25141 1.46672 2.40844 1.185 2.6925C0.90328 2.97656 0.749061 3.35297 0.750467 3.75V17.1595C0.750467 18.0661 1.39547 18.75 2.25047 18.75C5.88187 18.75 9.50531 19.0795 11.4145 21.4683C11.557 21.6464 11.7722 21.75 12.0005 21.75C12.2283 21.75 12.4439 21.6464 12.5859 21.4683C13.7152 20.0564 15.6075 18.75 21.7505 18.75C22.5773 18.75 23.2505 18.0769 23.2505 17.25V3.74156C23.2491 3.34172 23.092 2.96625 22.808 2.68453H22.8075Z" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.3236 8.80265C14.4708 8.99999 14.6962 9.10406 14.925 9.10406C15.0811 9.10406 15.2386 9.05577 15.3731 8.95499C16.1995 8.33812 17.4816 8.03109 19.4076 7.98937C19.822 7.98046 20.1502 7.63734 20.1412 7.22343C20.1323 6.81515 19.7986 6.48984 19.3917 6.48984H19.3753C17.1216 6.53859 15.5648 6.93984 14.4759 7.75312C14.1441 8.00062 14.0756 8.47078 14.3236 8.80265ZM14.3236 12.1673C14.4708 12.3647 14.6962 12.4688 14.925 12.4688C15.0811 12.4688 15.2386 12.4205 15.3731 12.3197C16.1995 11.7028 17.4816 11.3958 19.4076 11.3541C19.822 11.3452 20.1502 11.002 20.1412 10.5881C20.1323 10.1738 19.7916 9.84516 19.3753 9.85454C17.1216 9.90329 15.5648 10.3045 14.4759 11.1178C14.1441 11.3653 14.0756 11.8355 14.3236 12.1673ZM14.925 15.8334C14.6962 15.8334 14.4708 15.7294 14.3236 15.532C14.0756 15.2002 14.1441 14.73 14.4759 14.4825C15.5648 13.6692 17.1216 13.268 19.3753 13.2192C19.7897 13.2098 20.1323 13.5384 20.1412 13.9528C20.1502 14.3667 19.822 14.7098 19.4076 14.7188C17.4816 14.7605 16.1995 15.0675 15.3731 15.6844C15.2386 15.7847 15.0811 15.8334 14.925 15.8334ZM8.62687 12.3197C8.7614 12.42 8.9189 12.4687 9.07499 12.4687C9.30327 12.4687 9.52921 12.3647 9.6764 12.1673C9.9239 11.8355 9.85593 11.3658 9.52406 11.1178C8.43515 10.305 6.87843 9.90327 4.62468 9.85452H4.60827C4.2014 9.85452 3.86765 10.1794 3.85874 10.5881C3.84984 11.002 4.17843 11.3451 4.59234 11.3541C6.51843 11.3958 7.80046 11.7028 8.62687 12.3197ZM9.07499 9.10406C8.9189 9.10406 8.7614 9.05531 8.62687 8.95499C7.80046 8.33812 6.51843 8.03109 4.59234 7.98937C4.17843 7.98046 3.84984 7.63734 3.85874 7.22343C3.86765 6.81468 4.2014 6.48984 4.60827 6.48984H4.62468C6.87843 6.53859 8.43515 6.94031 9.52406 7.75312C9.85593 8.00109 9.9239 8.47078 9.6764 8.80265C9.52921 8.99999 9.30327 9.10406 9.07499 9.10406ZM8.62687 15.6844C8.7614 15.7847 8.9189 15.8334 9.07499 15.8334C9.30327 15.8334 9.52921 15.7294 9.6764 15.532C9.9239 15.2002 9.85593 14.7305 9.52406 14.4825C8.43515 13.6697 6.87843 13.268 4.62468 13.2192C4.21077 13.2089 3.86765 13.5389 3.85874 13.9528C3.84984 14.3667 4.17843 14.7099 4.59234 14.7188C6.51843 14.7605 7.80046 15.067 8.62687 15.6844Z", fill: "currentColor" })), q1 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M21.7523 2.25H21.7467C18.5775 2.26406 16.2136 2.66437 14.5205 3.47344C13.4091 4.00453 12.5742 4.70859 12.0005 5.60531C11.4262 4.70906 10.5919 4.00453 9.48047 3.47344C7.78734 2.66437 5.42344 2.26406 2.25047 2.25H2.24203C1.84219 2.25141 1.46672 2.40844 1.185 2.6925C0.90328 2.97656 0.749061 3.35297 0.750467 3.75V17.1595C0.750467 18.0661 1.39547 18.75 2.25047 18.75C5.88187 18.75 9.50531 19.0795 11.4145 21.4683C11.4155 21.4697 11.4169 21.4706 11.4178 21.472C11.4347 21.4927 11.452 21.5123 11.4708 21.5311C11.4727 21.533 11.475 21.5348 11.4769 21.5367C11.4937 21.5531 11.5111 21.5691 11.5298 21.5836C11.5364 21.5888 11.543 21.5934 11.55 21.5986C11.5645 21.6094 11.5791 21.6202 11.5945 21.63C11.602 21.6347 11.6095 21.6394 11.6175 21.6441C11.633 21.6534 11.6484 21.6619 11.6644 21.6698C11.6719 21.6736 11.6798 21.6773 11.6878 21.6811C11.7047 21.6886 11.7216 21.6956 11.7389 21.7022C11.7464 21.705 11.7539 21.7078 11.7619 21.7106C11.7802 21.7167 11.7984 21.7219 11.8172 21.7266C11.8247 21.7284 11.8317 21.7308 11.8392 21.7322C11.8589 21.7364 11.8791 21.7397 11.8992 21.7425C11.9058 21.7434 11.9123 21.7448 11.9194 21.7458C11.9456 21.7486 11.9723 21.7505 11.9995 21.7505C11.9995 21.7505 12.0005 21.7505 12.0009 21.7505C12.0286 21.7505 12.0558 21.7486 12.0825 21.7458C12.0891 21.7448 12.0956 21.7439 12.1022 21.743C12.1228 21.7402 12.143 21.7369 12.1627 21.7327C12.1702 21.7313 12.1772 21.7289 12.1842 21.727C12.203 21.7223 12.2217 21.7172 12.24 21.7111C12.2475 21.7087 12.255 21.7059 12.262 21.7031C12.2798 21.6966 12.2967 21.6895 12.3141 21.6816C12.3216 21.6783 12.3291 21.6745 12.3366 21.6708C12.353 21.6628 12.3689 21.6539 12.3844 21.6445C12.3919 21.6403 12.3994 21.6356 12.4064 21.6309C12.4219 21.6211 12.4369 21.6103 12.4519 21.5991C12.4584 21.5944 12.465 21.5897 12.4711 21.5845C12.4898 21.5695 12.5077 21.5536 12.525 21.5367C12.5264 21.5353 12.5283 21.5339 12.5302 21.532C12.5489 21.5133 12.5667 21.4931 12.5836 21.4725C12.5845 21.4716 12.5855 21.4702 12.5864 21.4692C13.7156 20.0573 15.608 18.7509 21.7509 18.7509C22.5778 18.7509 23.2509 18.0778 23.2509 17.2509V3.74156C23.2477 2.91797 22.5769 2.25 21.7533 2.25H21.7523ZM2.26406 17.25C2.2575 17.2322 2.25 17.2022 2.25 17.1595V3.75C5.96062 3.76688 10.3247 4.22297 11.25 7.59984V19.2417C9.35765 17.8448 6.58406 17.2509 2.26406 17.25ZM21.75 17.25C17.4225 17.25 14.6452 17.8439 12.75 19.2427V7.59656C13.2347 5.80312 14.7431 3.78187 21.75 3.74953V17.25Z" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.07501 9.10407C8.91892 9.10407 8.76141 9.05532 8.62688 8.95501C7.80048 8.33813 6.51845 8.0311 4.59235 7.98938C4.17845 7.98048 3.84985 7.63735 3.85876 7.22344C3.86766 6.80954 4.21079 6.47907 4.6247 6.48985C6.87845 6.5386 8.43516 6.94032 9.52407 7.7536C9.85595 8.00157 9.92391 8.47126 9.67641 8.80313C9.52923 9.00048 9.30329 9.10454 9.07501 9.10454V9.10407ZM14.3236 8.80265C14.4708 8.99999 14.6963 9.10406 14.925 9.10406C15.0811 9.10406 15.2386 9.05577 15.3731 8.95499C16.1995 8.33812 17.4816 8.03109 19.4077 7.98937C19.822 7.98046 20.1502 7.63734 20.1413 7.22343C20.1324 6.81515 19.7986 6.48984 19.3917 6.48984H19.3753C17.1216 6.53859 15.5649 6.93984 14.4759 7.75312C14.1441 8.00062 14.0756 8.47078 14.3236 8.80265ZM14.3236 12.1673C14.4708 12.3647 14.6963 12.4688 14.925 12.4688C15.0811 12.4688 15.2386 12.4205 15.3731 12.3197C16.1995 11.7028 17.4816 11.3958 19.4077 11.3541C19.822 11.3452 20.1502 11.002 20.1413 10.5881C20.1324 10.1738 19.7911 9.84516 19.3753 9.85454C17.1216 9.90329 15.5649 10.3045 14.4759 11.1178C14.1441 11.3653 14.0756 11.8355 14.3236 12.1673ZM14.925 15.8334C14.6963 15.8334 14.4708 15.7294 14.3236 15.532C14.0756 15.2001 14.1441 14.73 14.4759 14.4825C15.5649 13.6692 17.1216 13.268 19.3753 13.2192H19.3917C19.7981 13.2192 20.1324 13.5445 20.1413 13.9528C20.1502 14.3667 19.822 14.7098 19.4077 14.7187C17.4816 14.7605 16.1995 15.0675 15.3731 15.6844C15.2386 15.7847 15.0811 15.8334 14.925 15.8334ZM8.62688 12.3197C8.76141 12.42 8.91892 12.4688 9.07501 12.4688C9.30329 12.4688 9.52923 12.3647 9.67641 12.1673C9.92391 11.8355 9.85595 11.3658 9.52407 11.1178C8.43516 10.305 6.87845 9.90329 4.6247 9.85454C4.20985 9.84375 3.86766 10.1742 3.85876 10.5881C3.84985 11.002 4.17845 11.3452 4.59235 11.3541C6.51845 11.3958 7.80048 11.7028 8.62688 12.3197ZM8.62688 15.6844C8.76141 15.7847 8.91892 15.8334 9.07501 15.8334V15.8339C9.30329 15.8339 9.52923 15.7298 9.67641 15.5325C9.92391 15.2006 9.85595 14.7309 9.52407 14.483C8.43516 13.6697 6.87845 13.268 4.6247 13.2192C4.21079 13.2098 3.86766 13.5389 3.85876 13.9528C3.84985 14.3667 4.17845 14.7098 4.59235 14.7188C6.51845 14.7605 7.80048 15.0675 8.62688 15.6844Z", fill: "currentColor" })), J1 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M9.5625 9.25H3.1875C2.73995 9.25 2.31072 9.10868 1.99426 8.85713C1.67779 8.60558 1.5 8.2644 1.5 7.90865V2.84135C1.5 2.4856 1.67779 2.14442 1.99426 1.89287C2.31072 1.64132 2.73995 1.5 3.1875 1.5H9.5625C10.0101 1.5 10.4393 1.64132 10.7557 1.89287C11.0722 2.14442 11.25 2.4856 11.25 2.84135V7.90865C11.25 8.2644 11.0722 8.60558 10.7557 8.85713C10.4393 9.10868 10.0101 9.25 9.5625 9.25Z" }), /* @__PURE__ */ t.createElement("path", { d: "M20.8125 13.25H14.4375C13.9899 13.25 13.5607 13.0357 13.2443 12.6544C12.9278 12.273 12.75 11.7557 12.75 11.2163V3.53365C12.75 2.9943 12.9278 2.47703 13.2443 2.09564C13.5607 1.71426 13.9899 1.5 14.4375 1.5H20.8125C21.2601 1.5 21.6893 1.71426 22.0057 2.09564C22.3222 2.47703 22.5 2.9943 22.5 3.53365V11.2163C22.5 11.7557 22.3222 12.273 22.0057 12.6544C21.6893 13.0357 21.2601 13.25 20.8125 13.25Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { d: "M9.5625 22.5H3.1875C2.73995 22.5 2.31072 22.2857 1.99426 21.9044C1.67779 21.523 1.5 21.0057 1.5 20.4663V12.7837C1.5 12.2443 1.67779 11.727 1.99426 11.3456C2.31072 10.9643 2.73995 10.75 3.1875 10.75H9.5625C10.0101 10.75 10.4393 10.9643 10.7557 11.3456C11.0722 11.727 11.25 12.2443 11.25 12.7837V20.4663C11.25 21.0057 11.0722 21.523 10.7557 21.9044C10.4393 22.2857 10.0101 22.5 9.5625 22.5Z" }), /* @__PURE__ */ t.createElement("path", { d: "M20.8125 22.5H14.4375C13.9899 22.5 13.5607 22.3587 13.2443 22.1071C12.9278 21.8556 12.75 21.5144 12.75 21.1587V16.0913C12.75 15.7356 12.9278 15.3944 13.2443 15.1429C13.5607 14.8913 13.9899 14.75 14.4375 14.75H20.8125C21.2601 14.75 21.6893 14.8913 22.0057 15.1429C22.3222 15.3944 22.5 15.7356 22.5 16.0913V21.1587C22.5 21.5144 22.3222 21.8556 22.0057 22.1071C21.6893 22.3587 21.2601 22.5 20.8125 22.5Z" })), X1 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M9.5625 8.5H3.1875C2.89018 8.5 2.63039 8.4047 2.46094 8.27001C2.29586 8.13879 2.25 8.00264 2.25 7.90865V2.84135C2.25 2.74736 2.29586 2.61121 2.46094 2.47999C2.63039 2.3453 2.89018 2.25 3.1875 2.25H9.5625C9.85982 2.25 10.1196 2.3453 10.2891 2.47999C10.4541 2.61121 10.5 2.74736 10.5 2.84135V7.90865C10.5 8.00264 10.4541 8.13879 10.2891 8.27001C10.1196 8.4047 9.85982 8.5 9.5625 8.5Z", strokeWidth: 1.5 }), /* @__PURE__ */ t.createElement("path", { d: "M20.8125 12.5H14.4375C14.2388 12.5 14.0127 12.4059 13.8214 12.1754C13.6268 11.9409 13.5 11.5974 13.5 11.2163V3.53365C13.5 3.15264 13.6268 2.80913 13.8214 2.57457C14.0127 2.34406 14.2388 2.25 14.4375 2.25H20.8125C21.0112 2.25 21.2373 2.34406 21.4286 2.57457C21.6232 2.80913 21.75 3.15264 21.75 3.53365V11.2163C21.75 11.5974 21.6232 11.9409 21.4286 12.1754C21.2373 12.4059 21.0112 12.5 20.8125 12.5Z", stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ t.createElement("path", { d: "M9.5625 21.75H3.1875C2.98883 21.75 2.76271 21.6559 2.57143 21.4254C2.3768 21.1909 2.25 20.8474 2.25 20.4663V12.7837C2.25 12.4026 2.3768 12.0591 2.57143 11.8246C2.76271 11.5941 2.98883 11.5 3.1875 11.5H9.5625C9.76117 11.5 9.98729 11.5941 10.1786 11.8246C10.3732 12.0591 10.5 12.4026 10.5 12.7837V20.4663C10.5 20.8474 10.3732 21.1909 10.1786 21.4254C9.98729 21.6559 9.76117 21.75 9.5625 21.75Z", strokeWidth: 1.5 }), /* @__PURE__ */ t.createElement("path", { d: "M20.8125 21.75H14.4375C14.1402 21.75 13.8804 21.6547 13.7109 21.52C13.5459 21.3888 13.5 21.2526 13.5 21.1587V16.0913C13.5 15.9974 13.5459 15.8612 13.7109 15.73C13.8804 15.5953 14.1402 15.5 14.4375 15.5H20.8125C21.1098 15.5 21.3696 15.5953 21.5391 15.73C21.7041 15.8612 21.75 15.9974 21.75 16.0913V21.1587C21.75 21.2526 21.7041 21.3888 21.5391 21.52C21.3696 21.6547 21.1098 21.75 20.8125 21.75Z", strokeWidth: 1.5 })), K1 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M21.8906 2.11876C21.6963 1.92218 21.4648 1.76624 21.2096 1.66001C20.9544 1.55378 20.6806 1.49939 20.4042 1.50001H14.6419C14.2639 1.50071 13.9014 1.65045 13.6331 1.91672L2.1136 13.4339C1.72053 13.8278 1.49977 14.3615 1.49977 14.918C1.49977 15.4744 1.72053 16.0082 2.1136 16.402L7.59797 21.8864C7.99195 22.2797 8.52586 22.5005 9.0825 22.5005C9.63915 22.5005 10.1731 22.2797 10.567 21.8864L22.0819 10.3739C22.3487 10.1061 22.499 9.74369 22.5 9.36563V3.60001C22.5017 3.32503 22.4487 3.05247 22.3441 2.79817C22.2395 2.54388 22.0853 2.31292 21.8906 2.11876Z" }), /* @__PURE__ */ t.createElement("path", { d: "M17.1666 7.24721C17.4133 7.41203 17.7033 7.5 18 7.5C18.3978 7.5 18.7794 7.34197 19.0607 7.06066C19.342 6.77936 19.5 6.39783 19.5 6C19.5 5.70333 19.412 5.41332 19.2472 5.16665C19.0824 4.91997 18.8481 4.72771 18.574 4.61418C18.2999 4.50065 17.9983 4.47094 17.7074 4.52882C17.4164 4.5867 17.1491 4.72956 16.9393 4.93934C16.7296 5.14912 16.5867 5.41639 16.5288 5.70737C16.4709 5.99834 16.5007 6.29994 16.6142 6.57403C16.7277 6.84811 16.92 7.08238 17.1666 7.24721Z", fill: "currentColor" })), Q1 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.8239 3.17331C20.7695 3.11825 20.7046 3.07457 20.6331 3.04482C20.5617 3.01506 20.485 2.99983 20.4076 3L20.4042 3.00001L14.6712 3.00001L3.17535 14.4935C3.06322 14.6061 2.99977 14.759 2.99977 14.918C2.99977 15.0769 3.06273 15.2294 3.17486 15.342L8.65764 20.8248C8.77038 20.9372 8.92329 21.0005 9.0825 21.0005C9.24154 21.0005 9.39409 20.9375 9.50679 20.8253L21 9.33446V3.5907C21.0005 3.51462 20.9858 3.43921 20.9569 3.36886C20.928 3.2985 20.8853 3.2346 20.8314 3.18088L20.8239 3.17331ZM10.567 21.8864C10.1731 22.2797 9.63915 22.5005 9.0825 22.5005C8.52586 22.5005 7.99195 22.2797 7.59797 21.8864L2.1136 16.402C1.72053 16.0082 1.49977 15.4744 1.49977 14.918C1.49977 14.3615 1.72053 13.8278 2.1136 13.4339L13.6331 1.91672C13.9014 1.65045 14.2639 1.50071 14.6419 1.50001H20.4042C20.6806 1.49939 20.9544 1.55378 21.2096 1.66001C21.4648 1.76624 21.6963 1.92218 21.8906 2.11876C22.0853 2.31292 22.2395 2.54388 22.3441 2.79817C22.4487 3.05247 22.5017 3.32503 22.5 3.60001V9.36563C22.499 9.74369 22.3487 10.1061 22.0819 10.3739L10.567 21.8864Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { d: "M17.1666 7.24721C17.4133 7.41203 17.7033 7.5 18 7.5C18.3978 7.5 18.7794 7.34197 19.0607 7.06066C19.342 6.77936 19.5 6.39783 19.5 6C19.5 5.70333 19.412 5.41332 19.2472 5.16665C19.0824 4.91997 18.8481 4.72771 18.574 4.61418C18.2999 4.50065 17.9983 4.47094 17.7074 4.52882C17.4164 4.5867 17.1491 4.72956 16.9393 4.93934C16.7296 5.14912 16.5867 5.41639 16.5288 5.70737C16.4709 5.99834 16.5007 6.29994 16.6142 6.57403C16.7277 6.84811 16.92 7.08238 17.1666 7.24721Z" })), Y1 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M13.125 10.7888C13.8544 11.5697 14.7863 12 15.75 12C16.7142 12 17.6456 11.5697 18.3731 10.7883C19.0809 10.0275 19.5136 9.01219 19.5919 7.92891C19.6734 6.78469 19.3205 5.72531 18.5953 4.94625C17.8772 4.17469 16.867 3.75 15.75 3.75C14.625 3.75 13.6177 4.16719 12.8972 4.94063C12.1767 5.71406 11.8247 6.77531 11.9062 7.92938C11.9827 9.01125 12.4158 10.027 13.125 10.7888Z" }), /* @__PURE__ */ t.createElement("path", { d: "M9.57094 20.25H21.9295C22.1276 20.251 22.3232 20.2067 22.5015 20.1204C22.6798 20.0341 22.8359 19.9082 22.958 19.7522C23.0878 19.5825 23.1777 19.3857 23.2209 19.1765C23.2641 18.9673 23.2594 18.751 23.2073 18.5438C22.8145 16.9397 21.8353 15.6178 20.377 14.7211C19.0781 13.9219 17.4773 13.5 15.75 13.5C14.0559 13.5 12.412 13.9406 11.1206 14.7403C9.66563 15.6417 8.68781 16.9561 8.29313 18.5409C8.24039 18.748 8.23518 18.9643 8.27788 19.1736C8.32058 19.383 8.41008 19.58 8.53969 19.7498C8.66187 19.9065 8.81838 20.0331 8.99716 20.1198C9.17595 20.2065 9.37224 20.2511 9.57094 20.25Z" }), /* @__PURE__ */ t.createElement("path", { d: "M6.89062 12.1875C5.24109 12.1875 3.79078 10.6538 3.65625 8.76891C3.58969 7.80328 3.89062 6.91031 4.5 6.25547C5.10281 5.60719 5.95312 5.25 6.89062 5.25C7.82812 5.25 8.67187 5.60906 9.27797 6.26109C9.89203 6.92109 10.192 7.81219 10.1217 8.76984C9.98719 10.6542 8.53734 12.1875 6.89062 12.1875Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { d: "M6.89109 13.057C8.07375 13.057 9.14391 13.2586 9.96844 13.6617C10.0645 13.7086 10.1489 13.7541 10.2225 13.7972C10.2763 13.8288 10.3214 13.8733 10.3537 13.9267C10.386 13.9801 10.4044 14.0407 10.4073 14.103C10.4103 14.1653 10.3976 14.2274 10.3705 14.2836C10.3434 14.3398 10.3027 14.3884 10.252 14.4249C8.87578 15.4083 7.94437 16.7573 7.54688 18.3539C7.53937 18.383 7.53281 18.4125 7.52766 18.442C7.51196 18.5284 7.46643 18.6066 7.39902 18.6629C7.3316 18.7192 7.24657 18.75 7.15875 18.75H1.95563C1.77412 18.7508 1.59485 18.71 1.43159 18.6307C1.26834 18.5514 1.12544 18.4357 1.01391 18.2925C0.896358 18.1387 0.815105 17.9603 0.776223 17.7707C0.737341 17.5811 0.741837 17.3851 0.789375 17.1975C1.11422 15.893 1.91859 14.8125 3.11438 14.0705C4.16906 13.417 5.51016 13.057 6.89109 13.057Z", fill: "currentColor" })), e2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("title", null, "Team"), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.1264 10.7887C13.8539 11.5697 14.7858 12 15.75 12C16.7142 12 17.6456 11.5697 18.3727 10.7883C19.0809 10.0275 19.5136 9.01172 19.5919 7.92891C19.6744 6.78516 19.3205 5.72578 18.5958 4.94672C17.8777 4.17516 16.8741 3.75 15.75 3.75C14.6259 3.75 13.613 4.17281 12.8986 4.93969C12.1781 5.71266 11.8261 6.77437 11.9081 7.92797C11.9845 9.01125 12.4172 10.0275 13.1264 10.7887ZM13.9959 5.96203C14.4239 5.50266 15.0469 5.25 15.75 5.25C16.4456 5.25 17.0662 5.505 17.4975 5.96859C17.9353 6.43969 18.1477 7.09734 18.0956 7.82109C18.0422 8.56406 17.7506 9.255 17.2748 9.76641C16.8342 10.2394 16.2933 10.5 15.75 10.5C15.2067 10.5 14.6648 10.2394 14.2242 9.76641C13.748 9.25547 13.4569 8.56453 13.4044 7.82203C13.3514 7.07719 13.5562 6.43406 13.9959 5.96203Z" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.57094 20.25H21.9295C22.335 20.25 22.7105 20.0691 22.9584 19.7527C23.2191 19.4203 23.3119 18.9684 23.2078 18.5442C22.8145 16.9402 21.8358 15.6188 20.3775 14.722C19.0777 13.9228 17.4445 13.5005 15.7505 13.5005C14.0564 13.5005 12.4125 13.9406 11.1216 14.7408C9.66657 15.6422 8.68875 16.9566 8.29407 18.5409C8.18813 18.9652 8.28 19.417 8.54016 19.7498C8.7886 20.0677 9.16407 20.25 9.57094 20.25ZM21.7106 18.75H9.79032C10.1128 17.6208 10.8436 16.6777 11.9114 16.0158C12.968 15.3605 14.3213 15 15.75 15C17.1788 15 18.5433 15.3548 19.5914 15.9994C20.6597 16.6561 21.39 17.6048 21.7106 18.75Z" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.89063 12.1875C5.24157 12.1875 3.79172 10.6538 3.65813 8.76891C3.58969 7.80328 3.88829 6.91031 4.4986 6.25547C5.10282 5.60719 5.95219 5.25 6.89063 5.25C7.82907 5.25 8.67094 5.60906 9.27797 6.26156C9.89204 6.92156 10.192 7.81219 10.1231 8.76984C9.98719 10.6542 8.53735 12.1875 6.89063 12.1875ZM6.89063 6.75C6.37313 6.75 5.91329 6.9375 5.59594 7.27781C5.26782 7.62984 5.11501 8.10891 5.15438 8.66297C5.23219 9.76031 6.02719 10.6875 6.89063 10.6875C7.75407 10.6875 8.54766 9.75984 8.62688 8.66203C8.66579 8.12437 8.50688 7.63453 8.17969 7.28297C7.85954 6.93891 7.40204 6.75 6.89063 6.75Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { d: "M1.95562 18.75H7.21875L7.21922 18.7491C7.63359 18.7491 7.96922 18.4134 7.96922 17.9991C7.96922 17.5847 7.63359 17.2491 7.21922 17.2491H2.33718C2.60906 16.4686 3.14625 15.8147 3.90562 15.3445C4.7264 14.8359 5.78672 14.5561 6.89109 14.5561C7.85343 14.5561 8.65593 14.7094 9.34406 15.0248C9.72047 15.1973 10.1658 15.0319 10.3383 14.6555C10.5108 14.2791 10.3453 13.8338 9.9689 13.6613C9.08015 13.2544 8.07328 13.0566 6.89062 13.0566C5.51109 13.0566 4.17 13.4166 3.11531 14.07C1.91812 14.8116 1.11375 15.893 0.788434 17.1984C0.693278 17.5819 0.777653 17.9911 1.0139 18.293C1.24125 18.5836 1.58437 18.75 1.95562 18.75Z", fill: "currentColor" })), t2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.25 7.5C4.25 5.15579 6.15579 3.25 8.5 3.25C10.8442 3.25 12.75 5.15579 12.75 7.5V16.5C12.75 18.0158 13.9842 19.25 15.5 19.25C17.0158 19.25 18.25 18.0158 18.25 16.5V7H19.75V16.5C19.75 18.8442 17.8442 20.75 15.5 20.75C13.1558 20.75 11.25 18.8442 11.25 16.5V7.5C11.25 5.98421 10.0158 4.75 8.5 4.75C6.98421 4.75 5.75 5.98421 5.75 7.5V17H4.25V7.5Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 19C2.25 17.4812 3.48122 16.25 5 16.25C6.51878 16.25 7.75 17.4812 7.75 19C7.75 20.5188 6.51878 21.75 5 21.75C3.48122 21.75 2.25 20.5188 2.25 19Z" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.25 5C16.25 3.48122 17.4812 2.25 19 2.25C20.5188 2.25 21.75 3.48122 21.75 5C21.75 6.51878 20.5188 7.75 19 7.75C17.4812 7.75 16.25 6.51878 16.25 5Z" })), r2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.25 7.5C4.25 5.15579 6.15579 3.25 8.5 3.25C10.8442 3.25 12.75 5.15579 12.75 7.5V16.5C12.75 18.0158 13.9842 19.25 15.5 19.25C17.0158 19.25 18.25 18.0158 18.25 16.5V7H19.75V16.5C19.75 18.8442 17.8442 20.75 15.5 20.75C13.1558 20.75 11.25 18.8442 11.25 16.5V7.5C11.25 5.98421 10.0158 4.75 8.5 4.75C6.98421 4.75 5.75 5.98421 5.75 7.5V17H4.25V7.5Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 17.75C4.30964 17.75 3.75 18.3096 3.75 19C3.75 19.6904 4.30964 20.25 5 20.25C5.69036 20.25 6.25 19.6904 6.25 19C6.25 18.3096 5.69036 17.75 5 17.75ZM2.25 19C2.25 17.4812 3.48122 16.25 5 16.25C6.51878 16.25 7.75 17.4812 7.75 19C7.75 20.5188 6.51878 21.75 5 21.75C3.48122 21.75 2.25 20.5188 2.25 19Z" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 3.75C18.3096 3.75 17.75 4.30964 17.75 5C17.75 5.69036 18.3096 6.25 19 6.25C19.6904 6.25 20.25 5.69036 20.25 5C20.25 4.30964 19.6904 3.75 19 3.75ZM16.25 5C16.25 3.48122 17.4812 2.25 19 2.25C20.5188 2.25 21.75 3.48122 21.75 5C21.75 6.51878 20.5188 7.75 19 7.75C17.4812 7.75 16.25 6.51878 16.25 5Z" })), l2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M23.25 8.25C23.2491 7.45462 22.9328 6.69206 22.3704 6.12964C21.8079 5.56722 21.0454 5.25087 20.25 5.25H18V4.5C17.9994 3.90345 17.7621 3.33152 17.3403 2.9097C16.9185 2.48787 16.3465 2.25062 15.75 2.25H8.25C7.65345 2.25062 7.08152 2.48787 6.65969 2.9097C6.23787 3.33152 6.00062 3.90345 6 4.5V5.25H3.75C2.95462 5.25087 2.19206 5.56722 1.62964 6.12964C1.06722 6.69206 0.750869 7.45462 0.75 8.25V10.5H23.25V8.25ZM16.5 5.25H7.5V4.5C7.5 4.30109 7.57902 4.11032 7.71967 3.96967C7.86032 3.82902 8.05109 3.75 8.25 3.75H15.75C15.9489 3.75 16.1397 3.82902 16.2803 3.96967C16.421 4.11032 16.5 4.30109 16.5 4.5V5.25Z" }), /* @__PURE__ */ t.createElement("path", { d: "M15.75 12.375C15.75 12.6734 15.6315 12.9595 15.4205 13.1705C15.2095 13.3815 14.9234 13.5 14.625 13.5H9.375C9.07663 13.5 8.79048 13.3815 8.5795 13.1705C8.36853 12.9595 8.25 12.6734 8.25 12.375V12.1875C8.25 12.1378 8.23025 12.0901 8.19508 12.0549C8.15992 12.0198 8.11223 12 8.0625 12H0.75V18.75C0.75 19.5456 1.06607 20.3087 1.62868 20.8713C2.19129 21.4339 2.95435 21.75 3.75 21.75H20.25C21.0456 21.75 21.8087 21.4339 22.3713 20.8713C22.9339 20.3087 23.25 19.5456 23.25 18.75V12H15.9375C15.8878 12 15.8401 12.0198 15.8049 12.0549C15.7698 12.0901 15.75 12.1378 15.75 12.1875V12.375Z", fill: "currentColor" })), n2 = (e) => /* @__PURE__ */ t.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.75 11.25C0.75 10.8358 1.08579 10.5 1.5 10.5H22.5C22.9142 10.5 23.25 10.8358 23.25 11.25C23.25 11.6642 22.9142 12 22.5 12H1.5C1.08579 12 0.75 11.6642 0.75 11.25Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 10.5C9.41421 10.5 9.75 10.8358 9.75 11.25V12H14.25V11.25C14.25 10.8358 14.5858 10.5 15 10.5C15.4142 10.5 15.75 10.8358 15.75 11.25V12.375C15.75 12.6734 15.6315 12.9595 15.4205 13.1705C15.2095 13.3815 14.9234 13.5 14.625 13.5H9.375C9.07663 13.5 8.79048 13.3815 8.5795 13.1705C8.36852 12.9595 8.25 12.6734 8.25 12.375V11.25C8.25 10.8358 8.58579 10.5 9 10.5Z", fill: "currentColor" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.75 6.75C2.92157 6.75 2.25 7.42157 2.25 8.25V18.75C2.25 19.5784 2.92157 20.25 3.75 20.25H20.25C21.0784 20.25 21.75 19.5784 21.75 18.75V8.25C21.75 7.42157 21.0784 6.75 20.25 6.75H3.75ZM0.75 8.25C0.75 6.59315 2.09315 5.25 3.75 5.25H20.25C21.9069 5.25 23.25 6.59315 23.25 8.25V18.75C23.25 20.4069 21.9069 21.75 20.25 21.75H3.75C2.09315 21.75 0.75 20.4069 0.75 18.75V8.25Z" }), /* @__PURE__ */ t.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.25 3.75C8.05109 3.75 7.86032 3.82902 7.71967 3.96967C7.57902 4.11032 7.5 4.30109 7.5 4.5V6C7.5 6.41421 7.16421 6.75 6.75 6.75C6.33579 6.75 6 6.41421 6 6V4.5C6 3.90326 6.23705 3.33097 6.65901 2.90901C7.08097 2.48705 7.65326 2.25 8.25 2.25H15.75C16.3467 2.25 16.919 2.48705 17.341 2.90901C17.7629 3.33097 18 3.90326 18 4.5V6C18 6.41421 17.6642 6.75 17.25 6.75C16.8358 6.75 16.5 6.41421 16.5 6V4.5C16.5 4.30109 16.421 4.11032 16.2803 3.96967C16.1397 3.82902 15.9489 3.75 15.75 3.75H8.25Z" })), v = (e, r) => U(
  W(
    e ? "fill-primary-05 text-primary-03" : "fill-grey-05 text-grey-04"
  ),
  r
), z2 = ({
  className: e,
  isPrimary: r,
  ...l
}) => /* @__PURE__ */ c(
  I1,
  {
    className: v(r, e),
    ...l
  }
), I2 = ({
  className: e,
  isPrimary: r,
  ...l
}) => /* @__PURE__ */ c(
  N1,
  {
    className: v(r, e),
    ...l
  }
), N2 = ({
  className: e,
  isPrimary: r,
  ...l
}) => /* @__PURE__ */ c(
  j1,
  {
    className: v(r, e),
    ...l
  }
), F2 = ({
  className: e,
  isPrimary: r,
  ...l
}) => /* @__PURE__ */ c(
  D1,
  {
    className: v(r, e),
    ...l
  }
), j2 = ({
  className: e,
  isPrimary: r,
  ...l
}) => /* @__PURE__ */ c(
  P1,
  {
    className: v(r, e),
    ...l
  }
), D2 = ({
  className: e,
  isPrimary: r,
  ...l
}) => /* @__PURE__ */ c(
  U1,
  {
    className: v(r, e),
    ...l
  }
), W2 = ({
  className: e,
  isPrimary: r,
  ...l
}) => /* @__PURE__ */ c(
  _1,
  {
    className: v(r, e),
    ...l
  }
), P2 = ({
  className: e,
  isPrimary: r,
  ...l
}) => /* @__PURE__ */ c(
  q1,
  {
    className: v(r, e),
    ...l
  }
), U2 = ({
  className: e,
  isPrimary: r,
  ...l
}) => /* @__PURE__ */ c(
  J1,
  {
    className: v(r, e),
    ...l
  }
), _2 = ({
  className: e,
  isPrimary: r,
  ...l
}) => /* @__PURE__ */ c(Q1, { className: v(r, e), ...l }), $2 = ({
  className: e,
  isPrimary: r,
  ...l
}) => /* @__PURE__ */ c(Y1, { className: v(r, e), ...l }), q2 = ({
  className: e,
  isPrimary: r,
  ...l
}) => /* @__PURE__ */ c(e2, { className: v(r, e), ...l }), J2 = ({
  className: e,
  isPrimary: r,
  ...l
}) => /* @__PURE__ */ c(
  t2,
  {
    className: v(r, e),
    ...l
  }
), X2 = ({
  className: e,
  isPrimary: r,
  ...l
}) => /* @__PURE__ */ c(
  r2,
  {
    className: v(r, e),
    ...l
  }
), K2 = ({
  className: e,
  isPrimary: r,
  ...l
}) => /* @__PURE__ */ c(
  l2,
  {
    className: v(r, e),
    ...l
  }
), Q2 = ({
  className: e,
  isPrimary: r,
  ...l
}) => /* @__PURE__ */ c(
  n2,
  {
    className: v(r, e),
    ...l
  }
), d1 = (e, r) => U(
  W(
    e ? "stroke-primary-05 text-primary-03" : "stroke-grey-05 text-grey-04"
  ),
  r
), Y2 = ({
  className: e,
  isPrimary: r,
  ...l
}) => /* @__PURE__ */ c(
  W1,
  {
    className: d1(r, e),
    ...l
  }
), e5 = ({
  className: e,
  isPrimary: r,
  ...l
}) => /* @__PURE__ */ c(
  X1,
  {
    className: d1(r, e),
    ...l
  }
), _ = (e, r) => U(
  W(
    e ? "fill-primary-05 text-primary-03" : "fill-grey-05 text-grey-02"
  ),
  r
), t5 = ({
  className: e,
  isPrimary: r,
  ...l
}) => /* @__PURE__ */ c(
  F1,
  {
    className: _(r, e),
    ...l
  }
), r5 = ({
  className: e,
  isPrimary: r,
  ...l
}) => /* @__PURE__ */ c($1, { className: _(r, e), ...l }), l5 = ({
  className: e,
  isPrimary: r,
  ...l
}) => /* @__PURE__ */ c(K1, { className: _(r, e), ...l });
export {
  d2 as A,
  R2 as B,
  k2 as C,
  q2 as D,
  S2 as E,
  L2 as F,
  z2 as G,
  I2 as H,
  N2 as I,
  F2 as J,
  D2 as K,
  W2 as L,
  P2 as M,
  U2 as N,
  _2 as O,
  $2 as P,
  J2 as Q,
  X2 as R,
  f2 as S,
  K2 as T,
  Q2 as U,
  Y2 as V,
  e5 as W,
  t5 as X,
  r5 as Y,
  l5 as Z,
  v2 as a,
  g2 as b,
  m2 as c,
  c2 as d,
  A2 as e,
  x2 as f,
  s2 as g,
  G2 as h,
  w2 as i,
  i2 as j,
  b2 as k,
  h2 as l,
  j2 as m,
  Z2 as n,
  O2 as o,
  B2 as p,
  C2 as q,
  M2 as r,
  V2 as s,
  U as t,
  p2 as u,
  u2 as v,
  T2 as w,
  H2 as x,
  y2 as y,
  E2 as z
};
//# sourceMappingURL=index-fafba757.mjs.map
